import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HistoricEngine11 from "@/pages/HistoricEngine11";
import ProgramsOutreach from "@/pages/ProgramsOutreach";
import Conference2027Anniversary from "@/pages/Conference2027Anniversary";
import Membership from "@/pages/Membership";
import RentEngine11 from "@/pages/RentEngine11";
import DonateSponsor from "@/pages/DonateSponsor";
import EventsNews from "@/pages/EventsNews";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Leadership from "@/pages/Leadership";

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-ash min-h-screen">
        <BrowserRouter>
          <Toaster richColors position="top-right" theme="dark" />
          <Routes>
            {/* Internal leadership dashboard — NO public layout, NO navbar/footer, noindex. */}
            <Route path="/leadership" element={<Leadership />} />

            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/historic-engine-11" element={<HistoricEngine11 />} />
              <Route path="/programs-outreach" element={<ProgramsOutreach />} />
              <Route path="/2027" element={<Conference2027Anniversary />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/rent-engine-11" element={<RentEngine11 />} />
              <Route path="/donate-sponsor" element={<DonateSponsor />} />
              <Route path="/events-news" element={<EventsNews />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />

              {/* ----- Legacy redirects (keep print materials & QR variants working) ----- */}
              <Route path="/2027-conference" element={<Navigate to="/2027" replace />} />
              <Route path="/60th-anniversary" element={<Navigate to="/2027" replace />} />
              <Route path="/community-outreach" element={<Navigate to="/programs-outreach" replace />} />
              <Route path="/project-100" element={<Navigate to="/programs-outreach#project-100" replace />} />

              {/* 404 fallback → Home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
